// Telefone do cliente que entra na loja sem conta Google (CON-3683). No mesmo estilo de
// `cepFormata`/`cepDigitos`/`cepValido` do endereco: a tela mostra com mascara, o
// identificador e o pedido guardam so os digitos.

export function telefoneDigitos(valor: string): string {
  return (valor || '').replace(/\D/g, '').slice(0, 11);
}

// Formata enquanto digita: "(85", "(85) 9999-9", "(85) 99999-8888". Com 11 digitos o bloco
// do meio tem 5 (celular); ate 10, tem 4 (fixo).
export function telefoneFormata(valor: string): string {
  const d = telefoneDigitos(valor);
  if (!d) {
    return '';
  }
  if (d.length <= 2) {
    return `(${d}`;
  }
  const ddd = d.slice(0, 2);
  const resto = d.slice(2);
  const meio = d.length === 11 ? 5 : 4;
  if (resto.length <= meio) {
    return `(${ddd}) ${resto}`;
  }
  return `(${ddd}) ${resto.slice(0, meio)}-${resto.slice(meio)}`;
}

// DDD + numero: 10 digitos (fixo) ou 11 comecando com 9 depois do DDD (celular). DDD nao
// comeca com zero - zero na frente e o digito de longa distancia, nao parte do numero.
export function telefoneValido(valor: string): boolean {
  const d = telefoneDigitos(valor);
  if (d.length !== 10 && d.length !== 11) {
    return false;
  }
  if (d[0] === '0') {
    return false;
  }
  return d.length === 10 || d[2] === '9';
}
